import { PieChart, Pie, Cell, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { format, startOfMonth, endOfMonth, eachMonthOfInterval, subMonths } from 'date-fns';
import { es } from 'date-fns/locale';
import './Statistics.css';

const COLORS = ['#F58220', '#E67310', '#D96408', '#CC5500', '#BF4600', '#B23700', '#A52800'];

const Statistics = ({ denuncias }) => {
  const getDelitoStats = () => {
    const delitoCount = {};
    denuncias.forEach(denuncia => {
      denuncia.delitos.forEach(delito => {
        delitoCount[delito] = (delitoCount[delito] || 0) + 1;
      });
    });

    return Object.entries(delitoCount).map(([name, value]) => ({
      name,
      value
    }));
  };

  const getMonthlyStats = () => {
    const now = new Date();
    const sixMonthsAgo = subMonths(now, 5);
    const months = eachMonthOfInterval({ start: sixMonthsAgo, end: now });

    return months.map(month => {
      const monthStart = startOfMonth(month);
      const monthEnd = endOfMonth(month);
      
      const count = denuncias.filter(denuncia => {
        if (!denuncia.created_at) return false;
        const date = denuncia.created_at.toDate();
        return date >= monthStart && date <= monthEnd;
      }).length;

      return {
        name: format(month, 'MMM yyyy', { locale: es }),
        denuncias: count
      };
    });
  };

  const getAnonimatoStats = () => {
    const anonimas = denuncias.filter(d => d.denunciante?.es_anonimo).length;
    const identificadas = denuncias.length - anonimas;
    const porcentajeAnonimas = denuncias.length > 0 
      ? Math.round((anonimas / denuncias.length) * 100) 
      : 0;

    return { anonimas, identificadas, porcentajeAnonimas };
  };

  const delitoData = getDelitoStats();
  const monthlyData = getMonthlyStats();
  const anonimatoStats = getAnonimatoStats();

  return (
    <div className="statistics-section">
      <h2>Estadísticas</h2>
      
      <div className="charts-grid">
        <div className="chart-card card">
          <h3>Distribución por Tipo de Delito</h3>
          {delitoData.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={delitoData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  label={({ name, percent }) => `${name} (${(percent * 100).toFixed(0)}%)`}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {delitoData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          ) : (
            <div className="no-data">No hay datos disponibles</div>
          )}
        </div>

        <div className="chart-card card">
          <h3>Denuncias por Mes</h3>
          {monthlyData.length > 0 ? (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="denuncias" fill="#F58220" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="no-data">No hay datos disponibles</div>
          )}
        </div>

        <div className="chart-card card anonimato-card">
          <h3>Anonimato de Denuncias</h3>
          <div className="anonimato-stats">
            <div className="anonimato-item">
              <div className="anonimato-number">{anonimatoStats.porcentajeAnonimas}%</div>
              <div className="anonimato-label">Denuncias Anónimas</div>
            </div>
            <div className="anonimato-breakdown">
              <div className="breakdown-item">
                <span className="breakdown-label">Anónimas:</span>
                <span className="breakdown-value">{anonimatoStats.anonimas}</span>
              </div>
              <div className="breakdown-item">
                <span className="breakdown-label">Identificadas:</span>
                <span className="breakdown-value">{anonimatoStats.identificadas}</span>
              </div>
              <div className="breakdown-item">
                <span className="breakdown-label">Total:</span>
                <span className="breakdown-value">{denuncias.length}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;
